import React, { Component, createRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./home.css";
// import Video1 from "../../Video/video.mp4";
// import banner2img from "../../../Pages/images/bannerimage/mg-bn-dsc-0128.webp"
// import banner3img from "../../../Pages/images/bannerimage/windsor-bn-dsc-011.webp"
// import banner4img from "../../../Pages/images/bannerimage/as-bn-dsc-0451.webp"
// import banner5img from "../../../Pages/images/bannerimage/zs-bn-dsc-0109.webp"
// import banner6img from "../../../Pages/images/bannerimage/gr-bn-dsc-0251.webp"
// import banner7img from "../../../Pages/images/bannerimage/cm-bn-dsc-0431.webp"
// import banner8img from "../../../Pages/images/bannerimage/hc-bn-dsc-0493.webp"
// import banner9img from "../../../Pages/images/bannerimage/cuv-bn-dsc-033.webp"
// import banner10img from "../../../Pages/images/bannerimage/mg-bn-dsc-0124.webp"
import Box from "@mui/material/Box";
// import morris from "../../images/morris.jpg";
// import showroom from "../../images/Homeimg/DSC00677.jpg";
// import showroomInt from "../../images/Homeimg/DSC00704.jpg";
import Carosel from "../../Home/Components/carasole";
// import mgCar from "../../images/05.png";
// import Navbar from "./Nav";
import Footer from "./Footer";
import { CardImg } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Drawer,
  MenuItem,
  Divider,
  Menu,
  Collapse,
  Select,
  InputLabel,
  TextField,
  Grid,
  Dialog,
  FormControl,
  DialogContent,
  Typography,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Link } from "react-router-dom";
const banner1img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2F008-ev-product-bn.webp?alt=media&token=9f5105c6-9fff-4f62-acea-cefbbb77479c";
const banner2img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2F005-phev-homepage-bn.webp?alt=media&token=ab20883a-b6a6-46d5-975f-fb0ab87722cd";

const banner3img ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/0159-herocarousel-bn-dsc.webp?alt=media&token=16f1ba20-e41c-4cdd-b1e1-e38e827081ce"
const banner4img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2Fmgi-hector-bn-homepage-003.webp?alt=media&token=4be20ebf-9159-4aa8-a4d3-2741f5e5ae37";
const banner5img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2Fwindsor-bn-dsc-011.webp?alt=media&token=a68cc89d-1c33-45bb-8054-aed31e2db0e4";
const banner6img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2Fcuv-bn-dsc-033.webp?alt=media&token=569bee31-3151-4602-94e3-f92f5167cb63";
const banner7img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2Fas-bn-dsc-0451.webp?alt=media&token=06763787-4eea-40cd-99e2-4d9fb3bba8f5";
const banner8img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2Fzs-bn-dsc-0109.webp?alt=media&token=792d0048-c895-490e-bfcc-e7da01ab16f4";


const morris =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/home%2FWhatsApp%20Image%202026-06-07%20at%201.37.21%20PM.jpeg?alt=media&token=469c5c3f-1308-4d14-a044-ed8d49e4a387";
const showroom =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/home%2FWhatsApp%20Image%202026-06-07%20at%201.36.39%20PM.jpeg?alt=media&token=25a5d2d1-b3cc-4cb9-895d-6d8bb4809cb6";
const showroomInt =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/home%2FWhatsApp%20Image%202026-06-07%20at%201.36.39%20PM.jpeg?alt=media&token=25a5d2d1-b3cc-4cb9-895d-6d8bb4809cb6";
class Home extends Component {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.videoSliderRef = React.createRef();
    // this.state = {
    //   videoUrls1: [homebanner],
    //   open: false,
    //   address: "",
    //   name: "",
    //   email: "",
    //   mobile: "",
    //   modelType: "",
    //   dateTime: null,
    //   emailError: "",
    //   mobileError: "",
    //   openTestDrive: false,
    //   openService: false,
    //   name1: "",
    //   email1: "",
    //   mobile1: "",
    //   model: "",
    //   carRegisterationNumber: "",
    //   prefferedServiceCenterLocation: "",
    //   preferredDateforService: "",
    // };
    this.state = {
      mediaItems: [
        
        {type:"image", url: banner1img},
        { type: "image", url: banner2img },
        { type: "image", url: banner3img },
        { type: "image", url: banner4img },
        { type: "image", url: banner5img },
        { type: "image", url: banner6img },
         { type: "image", url: banner7img },
        { type: "image", url: banner8img },
        // { type: "image", url: banner9img },
      ],
      open: false,
      address: "",
      name: "",
      email: "",
      mobile: "",
      modelType: "",
      dateTime: null,
      emailError: "",
      mobileError: "",
      openTestDrive: false,
      openService: false,
      name1: "",
      email1: "",
      mobile1: "",
      model: "",
      carRegisterationNumber: "",
      prefferedServiceCenterLocation: "",
      preferredDateforService: "",
    };
  }

  handleVideoEnd = () => {
    if (this.sliderRef.current) {
      this.sliderRef.current.slickNext();
    }
  };

  handleTestDriveClick = (link) => {
    window.open(link, "_blank");
  };

componentDidMount() {
  this.props.viewAddesByStatus();
  window.scrollTo({ top: 0, behavior: "smooth" });

  console.log(
    this.props.client.addesByStatus,
    "this.props.client.addesByStatus"
  );
}
  handleClickOpen = () => {
    this.setState({ openTestDrive: true });
  };
  handleServiceClickOpen = () => {
    this.setState({ openService: true });
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Standard email regex
    return emailRegex.test(email);
  };
  validateMobile = (mobile) => {
    const mobileRegex = /^\+?\d{10,14}$/; // Mobile regex for 10 to 14 digits
    return mobileRegex.test(mobile);
  };
  handleSubmit = (event) => {
    event.preventDefault();
    const { email, mobile } = this.state;
    let valid = true;
    if (!this.validateEmail(email)) {
      this.setState({ emailError: "Please enter a valid email address" });
      valid = false;
    } else {
      this.setState({ emailError: "" });
    }
    if (!this.validateMobile(mobile)) {
      this.setState({ mobileError: "Please enter a valid mobile number" });
      valid = false;
    } else {
      this.setState({ mobileError: "" });
    }
    if (valid) {
      this.props.BookTestDrive(
        this.state.name,
        this.state.email,
        this.state.mobile,
        this.state.modelType,
        this.state.dateTime,
        this.state.address
      );
      this.setState({
        name: "",
        email: "",
        mobile: "",
        modelType: "",
        dateTime: "",
        address: "",
        openTestDrive: false,
        openService: false,
      });
      // this.handleClose();
    }
  };
  handleSubmit1 = (e) => {
    e.preventDefault();
    const {
      name1,
      email1,
      mobile1,
      model,
      carRegisterationNumber,
      prefferedServiceCenterLocation,
      preferredDateforService,
    } = this.state;
    this.props.AddServiceForm(
      name1,
      email1,
      mobile1,
      model,
      carRegisterationNumber,
      prefferedServiceCenterLocation,
      preferredDateforService
    );
    this.setState({
      openService: false,
      name1: "",
      email1: "",
      mobile1: "",
      model: "",
      carRegisterationNumber: "",
      prefferedServiceCenterLocation: "",
      preferredDateforService: "",
    });
  };
  render() {
    const { videoUrls1, open } = this.state;
    const sliderSettings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 1000,
      pauseOnHover: false,
    };

    const {
      openTestDrive,
      openService,
      address,
      name,
      email,
      mobile,
      modelType,
      dateTime,
      emailError,
      mobileError,
    } = this.state;

    const uniqueVideoUrls = [...new Set(videoUrls1)];

    const getResponsiveFontSize = () => {
      if (window.innerWidth <= 430) {
        return { textSize: "8px", boldTextSize: "12px" }; // Mobile (small screens)
      } else if (window.innerWidth <= 768) {
        return { textSize: "13px", boldTextSize: "17px" }; // Tablets
      } else if (window.innerWidth <= 1024) {
        return { textSize: "14px", boldTextSize: "22px" }; // Small laptops
      } else {
        return { textSize: "14px", boldTextSize: "25px" }; // Desktops and larger
      }
    };

    const textStyle = {
      fontFamily: "Roboto, sans-serif",
      fontSize: getResponsiveFontSize().textSize,
    };

    const boldTextStyle = {
      fontFamily: "Roboto, sans-serif",
      fontSize: getResponsiveFontSize().boldTextSize,
      fontWeight: "700",
    };

    return (
      <Grid container>
        {/* Video Section */}
        {/* <Grid item xs={12}>
          <Slider ref={this.videoSliderRef} {...sliderSettings}>
            <div className="video-slide">
              <video
                autoPlay
                muted
                controls={false}
                loop
                playsInline // Add this for iOS and macOS compatibility
                className="video"
                key={uniqueVideoUrls[0]} // Force re-render if URL changes
                onEnded={() => this.handleVideoEnd()}
              >
                <source src={uniqueVideoUrls[0]} type="video/mp4" />
              </video>
            </div>
          </Slider>
        </Grid> */}

        {/* bannersection */}

        <Grid
          item
          xs={12}
          sx={{
            mt: {
              xs: "70px", // mobile
              sm: "70px", // tablet
              md: "0px", // desktop
              lg: "0px", // large screens
            },
          }}
        >
          <div style={{ position: "relative" }}>
            <Slider
              ref={this.videoSliderRef}
              {...{
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: false,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: false,
                swipeToSlide: true,
              }}
            >
              {this.state.mediaItems.map((item, index) => (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    backgroundColor: "#000",
                  }}
                >
                  {/* ✅ Image / Video */}
                  {item.type === "video" ? (
                    <video
                      autoPlay
                      muted
                      loop
                      playsInline
                      controls={false}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    >
                      <source src={item.url} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={item.url}
                      alt={`slide-${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>
              ))}
            </Slider>

            {/* ✅ Left Button */}
            <button
              onClick={() => this.videoSliderRef.current.slickPrev()}
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.6)",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold",
                color: "#000",
                transition: "0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(255,255,255,0.9)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(255,255,255,0.6)")
              }
            >
              &#10094;
            </button>

            {/* ✅ Right Button */}
            <button
              onClick={() => this.videoSliderRef.current.slickNext()}
              style={{
                position: "absolute",
                top: "52%",
                right: "10px",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.6)",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold",
                color: "#000",
                transition: "0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(255,255,255,0.9)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(255,255,255,0.6)")
              }
            >
              &#10095;
            </button>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} sm={6} md={5}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                }}
              >
                {this.props.client.addesByStatus?.mediaType === "image" ? (
                  <img
                    src={this.props.client.addesByStatus?.image}
                    alt="Car"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "fill",
                    }}
                  />
                ) : (
                  <video
                    src={this.props.client.addesByStatus?.image}
                    autoPlay
                    muted
                    loop
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={7}>
              <Grid container>
                {[
                  { text: "Book a test drive", action: "modal" },
                  { text: "Get Quotations", link: "/pricing" },
                  { text: "Book Service Appointment", action: "modal-service" },
                  { text: "Download Brochure", link: "/brochure" },
                ].map((item, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    key={index}
                    id={`right${index + 1}`}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      margin: 0,
                      padding: "8px",
                      letterSpacing: { xs: "0.1px", md: "0.2px" },
                      wordSpacing: { xs: "0.3px", md: "2px" },
                      cursor: "pointer",
                      fontFamily: "KIAbodyLatinbasic_Regular",
                      // border: "1px solid transparent",
                      // "&:hover": {
                      //   border: "1px solid #ccc",
                      //   borderRadius: "4px",
                      // },
                    }}
                    onClick={(e) => {
                      if (item.action === "modal") {
                        this.handleClickOpen(); // Opens the modal for "Book a test drive"
                      } else if (item.action === "modal-service") {
                        this.handleServiceClickOpen(); // Opens the modal for "Book Service Appointment"
                      }
                    }}
                  >
                    {item.link ? (
                      <Link
                        to={item.link}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "7px",
                          textDecoration: "none",
                          justifyContent: "center",
                          fontSize: { xs: "12px", sm: "14px", md: "16px" },
                          color: "inherit",
                          width: "100%",
                          height: "100%",
                          fontFamily: "Roboto, sans-serif",
                        }}
                      >
                        <i
                          className={`fa-solid fa-${
                            index === 0
                              ? "car"
                              : index === 1
                              ? "quote-left"
                              : index === 2
                              ? "gears"
                              : "book"
                          }`}
                          style={{ marginRight: "8px" }}
                        ></i>
                        {item.text}
                      </Link>
                    ) : (
                      <>
                        <i
                          className={`fa-solid fa-${
                            index === 0
                              ? "car"
                              : index === 1
                              ? "quote-left"
                              : index === 2
                              ? "gears"
                              : "book"
                          }`}
                          style={{ marginRight: "8px" }}
                        ></i>
                        <p
                          style={{
                            margin: 0,
                            fontFamily: "KIAbodyLatinbasic_Regular",
                            // fontSize: { xs: "12px", sm: "14px", md: "18px" },
                          }}
                        >
                          {item.text}
                        </p>
                      </>
                    )}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* carousel images */}
        <Carosel BookTestDrive={this.props.BookTestDrive} />

        {/* Content part */}
        <Box sx={{ backgroundColor: "#fff" }}>

          {/* Block 1 — MG Legacy */}
          <Box sx={{ py: { xs: 5, md: 8 }, px: { xs: 2, md: 8 }, borderBottom: "1px solid #f0f0f0" }}>
            <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
              <Grid item xs={12} md={7}>
                <Typography sx={{ color: "#D12230", fontWeight: "bold", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", mb: 1.5, fontFamily: "Roboto, sans-serif" }}>
                  Our Heritage
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: "#1a1a1a", mb: 2.5, fontSize: { xs: "18px", md: "26px" }, lineHeight: 1.35 }}>
                  MOVING AHEAD WITH A CENTURY-OLD LEGACY!
                </Typography>
                <Typography sx={{ fontFamily: "Roboto, sans-serif", fontSize: { xs: "13px", md: "15px" }, color: "#555", lineHeight: 1.9 }}>
                  When Cecil Kimber founded MG, he could scarcely have imagined that his passion for motoring would forge a legacy lasting more than a century and stretching across continents. As we steer into the future, we remain guided by that same fervor, aspiring to craft cars that bring a smile to the faces of those behind the wheel. MG’s journey began with a simple yet profound idea: to create vehicles that inspire joy and deliver a thrilling driving experience. Over the decades, MG has embraced new technologies while staying true to its roots. From the classic MG T-Series to the modern MG Hector and ZS EV, each model reflects a commitment to innovation, quality, and the pure pleasure of driving. As we look to the future, we remain dedicated to creating vehicles that connect with drivers on a personal level, carrying forward the passion and spirit that have defined MG for over a century.
                </Typography>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box component="img" src={morris} alt="morris" sx={{ width: "100%", height: { xs: "220px", md: "340px" }, objectFit: "cover", borderRadius: "16px", boxShadow: "0 12px 40px rgba(0,0,0,0.12)" }} />
              </Grid>
            </Grid>
          </Box>

          {/* Block 2 — The Central Group */}
          <Box sx={{ py: { xs: 5, md: 8 }, px: { xs: 2, md: 8 }, backgroundColor: "#f7f7f7", borderBottom: "1px solid #ebebeb" }}>
            <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
              <Grid item xs={12} md={5} sx={{ order: { xs: 2, md: 1 } }}>
                <Box component="img" src={showroomInt} alt="showroom interior" sx={{ width: "100%", height: { xs: "220px", md: "340px" }, objectFit: "cover", borderRadius: "16px", boxShadow: "0 12px 40px rgba(0,0,0,0.12)" }} />
              </Grid>
              <Grid item xs={12} md={7} sx={{ order: { xs: 1, md: 2 } }}>
                <Typography sx={{ color: "#D12230", fontWeight: "bold", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", mb: 1.5, fontFamily: "Roboto, sans-serif" }}>
                  Our Group
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: "#1a1a1a", mb: 2.5, fontSize: { xs: "18px", md: "26px" }, lineHeight: 1.35 }}>
                  THE CENTRAL GROUP
                </Typography>
                <Typography sx={{ fontFamily: "Roboto, sans-serif", fontSize: { xs: "13px", md: "15px" }, color: "#555", lineHeight: 1.9 }}>
                  The Central Group is a leading dealership group based in Odisha, with a robust presence across key locations, including Sambalpur, Angul, Jharsuguda, Jajpur, Bhubaneswar, Cuttack, Puri, Nayagarh, Berhampur, Ganjam, Phulbani, and Vizag. Representing premier automotive brands such as Kia, Honda, Renault, Tata Small Commercial Vehicle, MG Motors, and the soon-to-open BYD showroom, the Central Group is dedicated to offering exceptional vehicles and outstanding customer service. Their widespread network and commitment to excellence have established them as a trusted name in the automotive industry across the region.
                </Typography>
              </Grid>
            </Grid>
          </Box>

          {/* Block 3 — MG Central Odisha */}
          <Box sx={{ py: { xs: 5, md: 8 }, px: { xs: 2, md: 8 } }}>
            <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
              <Grid item xs={12} md={7}>
                <Typography sx={{ color: "#D12230", fontWeight: "bold", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", mb: 1.5, fontFamily: "Roboto, sans-serif" }}>
                  About Us
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: "bold", fontFamily: "Roboto, sans-serif", color: "#1a1a1a", mb: 2.5, fontSize: { xs: "18px", md: "26px" }, lineHeight: 1.35 }}>
                  MG CENTRAL ODISHA | PREMIER MG DEALERSHIP NETWORK HECTOR, GLOSTER, ASTOR, ZS EV | SALES &amp; SERVICE
                </Typography>
                <Typography sx={{ fontFamily: "Roboto, sans-serif", fontSize: { xs: "13px", md: "15px" }, color: "#555", lineHeight: 1.9 }}>
                  MG Central, your premier MG dealership in Odisha, is located in Khandagiri, Bhubaneswar. We offer an extensive range of MG vehicles, including the Hector, Gloster, Astor, and ZS EV, catering to diverse needs and preferences. Our state-of-the-art service center ensures that your MG receives top-notch care and maintenance. Visit MG Central in Khandagiri for exceptional deals, expert service, and outstanding customer support. Discover the latest MG models and experience unparalleled service at MG Central, your trusted MG dealer in Odisha.
                </Typography>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box component="img" src={showroom} alt="showroom" sx={{ width: "100%", height: { xs: "220px", md: "340px" }, objectFit: "cover", borderRadius: "16px", boxShadow: "0 12px 40px rgba(0,0,0,0.12)" }} />
              </Grid>
            </Grid>
          </Box>

        </Box>

        {/* Fotter Upper Part */}
        <div
          id="calc"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxSizing: "border-box",
            padding: "5px 0",
          }}
        >
          <div
            className="clc"
            style={{
              display: "flex",
              alignItems: "center",
              minWidth: "180px",
              padding: "5px",
              boxSizing: "border-box",
            }}
          >
            <Link
              to="/pricing"
              style={{
                textDecoration: "none",
                display: "flex",
                color: "white",
                gap: "5px",
              }}
            >
              <i
                className="fa-solid fa-quote-left"
                style={{ fontSize: "1.05em" }}
              ></i>
              <p style={{ margin: 0, fontSize: "0.8em", fontWeight: "550" }}>
                GET QUOTATIONS
              </p>
            </Link>
          </div>

          <div
            className="clc"
            style={{
              display: "flex",
              alignItems: "center",
              flex: "1 1 auto",
              gap: "5px",
              minWidth: "300px",
              padding: "5px",
              boxSizing: "border-box",
              cursor: "pointer",
            }}
            onClick={() => {
              if (/Mobi|Android/i.test(navigator.userAgent)) {
                window.location.href = "tel:8599005857";
              } else {
                alert("Calling is only available on mobile devices.");
              }
            }}
          >
            <i
              className="fa-solid fa-location-pin"
              style={{ fontSize: "1.05em" }}
            ></i>
            <p style={{ margin: 0, fontSize: "0.8em", fontWeight: "550" }}>
              CONNECT WITH MG EXPERT
            </p>
          </div>

          <div
            className="clc"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              minWidth: "180px",
              padding: "5px 10px",
              boxSizing: "border-box",
              cursor: "pointer",
              whiteSpace: "no-wrap",
            }}
          >
            <Link
              to="/brochure"
              style={{
                textDecoration: "none",
                display: "flex",
                color: "white",
                gap: "5px",
              }}
            >
              <i
                className="fa-solid fa-book"
                style={{ fontSize: "1.05em" }}
              ></i>
              <p
                style={{
                  margin: 0,
                  fontSize: "0.8em",
                  fontWeight: "550",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                CAR BROCHURES
              </p>
            </Link>
          </div>
        </div>

        {/*Footer  */}
        <Footer />

        {/* Service */}
        <Dialog
          open={this.state.openService}
          onClose={(e) => {
            this.setState({ openService: false });
          }}
          maxWidth="md"
          fullWidth
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                width: "800px",
              }}
            >
              <Typography
                sx={{
                  color: "#D62E31",
                  textAlign: "center",
                  fontSize: { md: "40px", xs: "20px", sm: "35px" },
                  fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
                  fontWeight: "bolder",
                }}
              >
                Service Appointment Form
              </Typography>
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "black",
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ openService: false });
              }}
            >
              <CloseIcon />
            </Box>
          </Box>
          <DialogContent>
            <form onSubmit={this.handleSubmit1}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Please fill in the mandatory details for Service
                    Appointment.
                  </Typography>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Name"
                      name="name"
                      fullWidth
                      required
                      value={this.state.name1}
                      onChange={(e) => this.setState({ name1: e.target.value })}
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Email"
                      name="email"
                      type="email"
                      fullWidth
                      required
                      value={this.state.email1}
                      onChange={(e) =>
                        this.setState({ email1: e.target.value })
                      }
                      error={!!this.state.emailError}
                      helperText={this.state.emailError}
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Mobile"
                      name="mobile"
                      type="number"
                      fullWidth
                      required
                      value={this.state.mobile1}
                      onChange={(e) =>
                        this.setState({ mobile1: e.target.value })
                      }
                      error={!!this.state.mobileError}
                      helperText={this.state.mobileError}
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth margin="dense" required>
                      <InputLabel
                        sx={{ "& .MuiInputLabel-asterisk": { color: "red" } }}
                      >
                        Model
                      </InputLabel>
                      <Select
                        name="modelType"
                        value={this.state.model}
                        onChange={(e) =>
                          this.setState({ model: e.target.value })
                        }
                      >
                        <MenuItem value="Hector">MG Hector</MenuItem>
                        <MenuItem value="Hector Tomahawk EV">Hector Tomahawk EV</MenuItem>
                        <MenuItem value="Hector Tomahawk PHEV">Hector Tomahawk PHEV</MenuItem>
                        <MenuItem value="Astor">MG Astor</MenuItem>
                        <MenuItem value="Gloster">MG Gloster</MenuItem>
                        <MenuItem value="ZsEv">MG ZS EV</MenuItem>
                        <MenuItem value="CometEv">MG Comet EV</MenuItem>
                        <MenuItem value="Windsor">MG Windsor</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Car Registration Number"
                      type="text"
                      variant="standard"
                      placeholder="e.g: OD39ZZ5697"
                      name="carRegistrationNumber"
                      value={this.state.carRegisterationNumber}
                      onChange={(e) =>
                        this.setState({
                          carRegisterationNumber: e.target.value,
                        })
                      }
                      InputLabelProps={{
                        sx: {
                          "& .MuiInputLabel-asterisk": { color: "#d32f2f" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required variant="standard">
                      <InputLabel
                        sx={{
                          "& .MuiInputLabel-asterisk": { color: "#d32f2f" },
                        }}
                      >
                        Preferred Service Center Location
                      </InputLabel>
                      <Select
                        label="Preferred Service Center Location"
                        name="preferredServiceCenterLocation"
                        value={this.state.prefferedServiceCenterLocation}
                        onChange={(e) =>
                          this.setState({
                            prefferedServiceCenterLocation: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="bbsr">Bhubaneswar</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    margin="dense"
                    label="Preferred Date for Service"
                    name="preferredDateForService"
                    type="datetime-local"
                    fullWidth
                    value={this.state.preferredDateforService}
                    onChange={(e) =>
                      this.setState({ preferredDateforService: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                    required
                  />
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ backgroundColor: "#D23132", fontWeight: "bolder" }}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </form>
          </DialogContent>
        </Dialog>
        {/* Test Drive */}
        <Dialog
          open={openTestDrive}
          onClose={(e) => {
            this.setState({ openTestDrive: false });
          }}
          maxWidth="md"
          fullWidth
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                width: "800px",
              }}
            >
              <Typography
                sx={{
                  color: "#D62E31",
                  textAlign: "center",
                  fontSize: { md: "40px", xs: "20px", sm: "35px" },
                  fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
                  fontWeight: "bolder",
                }}
              >
                Book a Test Drive
              </Typography>
            </Box>
            <Box
              sx={{
                width: "50px",
              }}
              onClick={(e) => {
                this.setState({ openTestDrive: false });
              }}
            >
              <CloseIcon />
            </Box>
          </Box>
          <DialogContent>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Please fill in the mandatory details for booking a Test
                    Drive.
                  </Typography>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Name"
                      name="name"
                      fullWidth
                      value={name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                      required
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Email"
                      name="email"
                      type="email"
                      fullWidth
                      value={email}
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                      required
                      error={!!emailError}
                      helperText={emailError}
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Mobile"
                      name="Mobile"
                      type="number"
                      fullWidth
                      value={mobile}
                      onChange={(e) => {
                        this.setState({ mobile: e.target.value });
                      }}
                      required
                      error={!!mobileError}
                      helperText={mobileError}
                      InputLabelProps={{
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth margin="dense" required>
                      <InputLabel
                        sx={{ "& .MuiInputLabel-asterisk": { color: "red" } }}
                      >
                        Model Type
                      </InputLabel>
                      <Select
                        name="modelType"
                        value={modelType}
                        onChange={(e) => {
                          this.setState({ modelType: e.target.value });
                        }}
                      >
                        <MenuItem value="Hector">MG Hector</MenuItem>
                        <MenuItem value="Hector Tomahawk EV">Hector Tomahawk EV</MenuItem>
                        <MenuItem value="Hector Tomahawk PHEV">Hector Tomahawk PHEV</MenuItem>
                        <MenuItem value="Astor">MG Astor</MenuItem>
                        <MenuItem value="Gloster">MG Gloster</MenuItem>
                        <MenuItem value="ZsEv">MG ZS EV</MenuItem>
                        <MenuItem value="CometEv">MG Comet EV</MenuItem>
                        <MenuItem value="Windsor">MG Windsor</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Test Drive Date & Time"
                      name="date"
                      type="datetime-local"
                      fullWidth
                      value={dateTime}
                      onChange={(e) => {
                        this.setState({ dateTime: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      margin="dense"
                      label="Address"
                      name="address"
                      type="text"
                      fullWidth
                      value={address}
                      onChange={(e) => {
                        this.setState({ address: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                      }}
                      required
                    />
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ backgroundColor: "#D23132", fontWeight: "bolder" }}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </form>
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default Home;
